module.exports = __webpack_public_path__ + "assets/img/img-hotel-07.ad7c82e6.jpg";